import { render, staticRenderFns } from "./RentPayerLandlord.vue?vue&type=template&id=405e4f45&scoped=true&"
import script from "./RentPayerLandlord.vue?vue&type=script&lang=js&"
export * from "./RentPayerLandlord.vue?vue&type=script&lang=js&"
import style0 from "./RentPayerLandlord.vue?vue&type=style&index=0&id=405e4f45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405e4f45",
  null
  
)

export default component.exports